import React, { Fragment } from "react";
import propTypes from "prop-types";
import { IconButton } from "@mui/material";
import {
  FiAlertTriangle,
  FiCheckCircle,
  FiClock,
  FiDownload,
  FiUpload,
} from "react-icons/fi";

import styles from "./styles";
import flex from "../../../../styles/flex";

import { Ingestion } from "../../../../logic/api";

import ListViewItemCard from "../../../cards/ListItemCard/ListItemCard";

import { useDate } from '../../../../utility/useDate';
import { useTranslation } from "react-i18next";

function downloadObjectAsJson(exportStr: string, exportName: string) {
  try {
    const dataStr =
      "data:text/json;charset=utf-8," +
      encodeURIComponent(JSON.stringify(JSON.parse(exportStr), null, 2));
    const downloadAnchorNode = document.createElement("a");
    downloadAnchorNode.setAttribute("href", dataStr);
    downloadAnchorNode.setAttribute("download", exportName + ".json");
    document.body.appendChild(downloadAnchorNode); // required for firefox
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  } catch (ex) {
    console.log(ex);
  }
}

const IngestionListItem: React.FunctionComponent<{
  ingestion: Ingestion;
  selectedForRetry: boolean;
  onClick: () => void;
  onRetry: () => void;
}> = (props) => {
  const { toFormattedDateTimeString } = useDate();
  const { t } = useTranslation();

  return (
    <div
      style={{ ...styles.bookingListItem }}
      onClick={() => {
        if (props.onClick != null) {
          props.onClick();
        }
      }}
    >
      <div
        style={{
          position: "absolute",
          textAlign: "center",
          width: 120,
          left: -67,
          bottom: 0,
          height: 15,
          top: 30,
          fontSize: 10,
          overflow: "hidden",
          textOverflow: "ellipsis",
          color: "white",
          transform: "rotate(270deg)",
        }}
      >
        <span>{t("booking.labels.ingestion")}</span>
      </div>
      <div style={styles.bookingListItemFlex}>
        <ListViewItemCard
          icon={
            props.ingestion.isError == true ? (
              <FiAlertTriangle color="red" style={styles.icon} />
            ) : (
              <FiCheckCircle color="green" style={styles.icon} />
            )
          }
          wrap={false}
          text={
            props.ingestion.retryCount == 0
              ? toFormattedDateTimeString(new Date(props.ingestion.createDate))
              : t("lists.retryCount", { date: toFormattedDateTimeString(new Date(props.ingestion.createDate)), count: props.ingestion.retryCount })
          }
          subText={`${props.ingestion.message == null ? "" : props.ingestion.message
            } ${props.ingestion.reference == null
              ? ""
              : ` (${props.ingestion.reference})`
            }`}
        />

        <ListViewItemCard
          icon={null}
          text={
            props.ingestion.clientCode == null
              ? t("lists.unknown")
              : props.ingestion.clientCode
          }
          subText={props.ingestion.topic}
        />

        <div style={{ ...flex.flexAuto, textAlign: "center", minWidth: 80 }}>
          {props.ingestion.content != null && (
            <Fragment>
              <IconButton
                onClick={() => {
                  downloadObjectAsJson(
                    props.ingestion.content,
                    `${props.ingestion.id}-${props.ingestion.topic}`
                  );
                }}
              >
                <FiDownload />
              </IconButton>
              <div>
                <small>{t("general.download")}</small>
              </div>
            </Fragment>
          )}
        </div>
        <div style={{ ...flex.flexAuto, textAlign: "center", minWidth: 80 }}>


          <Fragment>
            {props.selectedForRetry == false && (props.ingestion.content != null && props.ingestion.content != "") && (
              <Fragment>
                <IconButton
                  onClick={() => {
                    props.onRetry();
                  }}
                >
                  <FiUpload />
                </IconButton>
                <div>
                  <small>{t("general.retry")}</small>
                </div>
              </Fragment>
            )}
            {props.selectedForRetry == true && (props.ingestion.content != null && props.ingestion.content != "") && (
              <Fragment>
                <IconButton
                  onClick={() => {
                    props.onRetry();
                  }}
                >
                  <FiClock color="orange" />
                </IconButton>
                <div>
                  <small>{t("general.queued")}</small>
                </div>
              </Fragment>
            )}
          </Fragment>

        </div>
      </div>
    </div>
  );
};

IngestionListItem.propTypes = {
  ingestion: propTypes.any.isRequired,
  selectedForRetry: propTypes.bool.isRequired,
  onClick: propTypes.func.isRequired,
  onRetry: propTypes.func.isRequired,
};

export default IngestionListItem;
